import toast from "react-hot-toast";
import { DataHelper } from "src/services/dataHelper";

export class AddItemToCarts {
    async handleAddToCart(customerId = null, data, quantity = 1, message, Action, orderStatus) {
        if (!data) {
            toast.error("Missing required parameters");
            return;
        }

        const qty = quantity;
        const unitPrice = data.salePrice || 0;
        const disc = data.disc || 0;
        const costPrice = (data.cost || 0) * qty;
        const isTaxIncluded_SalePrice = data.isTaxIncluded_SalePrice ?? false;
        const loyaltyPoints = (data.loyaltyPoints || 0) * qty;

        let totalWithTaxIncluded = 0;
        let tax = 0;
        let price = 0;
        let disc1Amount = 0;
        let discPer = 0;
        let promotionName = "";

        const actualPrice = unitPrice * qty;

        // ✅ Discount calculation
        if (disc > 0) {
            discPer = disc / 100;
            disc1Amount = actualPrice * discPer;
        } else if (
            data.activeStatus &&
            data.today >= data.fromDate &&
            data.today <= data.expireDate
        ) {
            const validDay = [
                data.sun,
                data.mon,
                data.tue,
                data.wed,
                data.thu,
                data.fri,
                data.sat,
            ].some(Boolean);

            if (validDay) {
                const minSaleQty = data.minSalesQty || 0;
                const nextDiscQty =
                    minSaleQty > 0 ? Math.trunc(qty / minSaleQty) * minSaleQty : 0;
                if (nextDiscQty > 0) {
                    discPer = (data.discountPercent || 0) / 100;
                    promotionName = data.promotionName || "";
                    disc1Amount =
                        data.discountPercent === 0
                            ? (data.gotFixAmount || 0) * nextDiscQty
                            : unitPrice * nextDiscQty * discPer;
                }
            }
        }

        const priceAfterDiscount = actualPrice - disc1Amount;

        // ✅ Tax calculation
        const taxPercent = data.taxPercent1 || 0;
        if (isTaxIncluded_SalePrice) {
            totalWithTaxIncluded = priceAfterDiscount / (1 + taxPercent);
            tax = priceAfterDiscount - totalWithTaxIncluded;
            price = priceAfterDiscount;
        } else {
            tax = priceAfterDiscount * taxPercent;
            price = priceAfterDiscount + tax;
            totalWithTaxIncluded = priceAfterDiscount;
        }

        // ✅ Line details
        const lineDetails = [
            {
                itemId: data.ID,
                itemName: data.englishName,
                englishName: data.englishName,
                arabicName: data.arabicName,
                code: data.code,
                saleTaxId: data.saleTaxId,
                purchaseTaxId: data.purchaseTaxId,
                unitId: data.unitId,
                categoryId: data.categoryId,
                remarks: "",
                promotionName,
                quantity: qty,
                unitPrice,
                lineNetAmount: parseFloat(price.toFixed(2)),
                costPrice: parseFloat(costPrice.toFixed(2)),
                lineTotal: parseFloat(totalWithTaxIncluded.toFixed(2)),
                taxAmount: parseFloat(tax.toFixed(2)),
                disc1Amount: parseFloat(disc1Amount.toFixed(2)),
                loyaltyPoints: parseFloat(loyaltyPoints.toFixed(2)),
                notes: "",
                notes1: "",
                notes2: "",
                disc,
                taxPercent,
                discount1: discPer,
                kitchenStatus: "",
                returnInvoiceNo: "",
                selectedSize: data.selectedSize ?? "",
                selectedColor: data.selectedColor ?? ""
            },
        ];

        // ✅ Totals
        const totalNetAmount = lineDetails.reduce(
            (sum, item) => sum + (item.lineNetAmount || 0),
            0
        );
        const totalLineAmount = lineDetails.reduce(
            (sum, item) => sum + (item.lineTotal || 0),
            0
        );
        const totalTaxAmount = lineDetails.reduce(
            (sum, item) => sum + (item.taxAmount || 0),
            0
        );
        const totalDiscAmount = lineDetails.reduce(
            (sum, item) => sum + (item.disc1Amount || 0),
            0
        );
        const totalCostAmount = lineDetails.reduce(
            (sum, item) => sum + (item.costPrice || 0),
            0
        );
        const totalLoyaltyPoints = lineDetails.reduce(
            (sum, item) => sum + (item.loyaltyPoints || 0),
            0
        );

        // ✅ Order head
        const orderHead = {
            orderNo: Math.floor(10000 + Math.random() * 90000),
            customerId,
            netAmount: parseFloat(totalNetAmount.toFixed(2)),
            grossAmount: parseFloat(totalLineAmount.toFixed(2)),
            totalTaxAmount: parseFloat(totalTaxAmount.toFixed(2)),
            totalDiscountAmount: parseFloat(totalDiscAmount.toFixed(2)),
            costAmount: parseFloat(totalCostAmount.toFixed(2)),
            loyaltyPoints: parseFloat(totalLoyaltyPoints.toFixed(2)),
            surchage: 0,
            deliveryCharge: 0,
            paymentMethod: "",
            orderStatus: orderStatus,
            paymentStatus: "Pending",
            paymentDate: new Date(),
            returnInvoiceNo: null,
            remarks: null,
            mobileNo: null,
            printNotes: "",
            kitchenStatus: "",
            guest: 0,
            tableId: null,
            otherCustomerId: null,
            addressId: null,
            invoiceNo: null,
            serviceProviderId: null,
            WSID: null,
            sessionId: new Date().getTime(),
            invoiceType: "Sale",
            currencyRate: 1,
            locationID: null,
            vendorID: null,
            action: Action
        };

        const operationsHeadPaymentTypes = [
            {
                paymentTypeID: 2,
                amount: parseFloat(totalNetAmount.toFixed(2)) || 0,
            },
        ];

        try {
            const dataPayload = {
                Head: orderHead,
                Details: lineDetails,
                operationExpenses: [],
                operationsHeadPaymentTypes,
                operationAssets: [],
            };
            console.log(dataPayload);
            const res = await new DataHelper().saveOperationPOS(
                "Operations",
                dataPayload
            );

            const body = res?.data;

            // New API envelope: { success, message, warning, data }
            if (body && typeof body.success === "boolean") {
                return {
                    status: res.status,
                    success: body.success,
                    message: body.message,
                    warning: body.warning,
                    data: body.data ?? null,
                };
            }

            // Legacy payload (status / ID on res.data)
            return {
                status: res?.status,
                success: res?.status === 200,
                message: body?.status || body?.message || message || "Success",
                warning: body?.warning,
                data: body ?? null,
            };
        } catch (error) {
            console.error("❌ Error saving order:", error);
            const errBody = error?.response?.data;
            return {
                status: error?.response?.status || 500,
                success: false,
                message:
                    errBody?.message ||
                    error?.message ||
                    "Something went wrong. Please try again.",
                warning: errBody?.warning,
                data: null,
            };
        }
    }
}
